import { checkUserModules } from './CheckUserModules';

// Ruta a la que debe entrar el POS justo despues del login (o al recuperar una sesion ya valida).
// La maquina define su pantalla inicial (machine.startup_view, ver sql/machine_startup_view.sql en
// el dashboard): 'POS' es el comportamiento de siempre, 'TABLES' entra directo al modulo de Mesas
// (Reservation). Cualquier valor ausente, nulo o no reconocido cae a POS para no afectar maquinas
// existentes. startup_view NO concede permisos: si el usuario logueado no tiene el modulo de mesas,
// o la sucursal no tiene mesas habilitadas, se respeta esa validacion (ya usada por el boton
// "Mesas" en PaymentPost.jsx) y se entra a POS igual.
export const getStartupPath = (business_code, branchoffice_code) => {
    const posPath = `/payments/${business_code}/${branchoffice_code}`;
    try {
        const machine = JSON.parse(localStorage.getItem('machine') || 'null');
        if (machine?.startup_view !== 'TABLES') return posPath;

        const branchoffice = JSON.parse(localStorage.getItem('branchoffice') || 'null');
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        const hasTablesEnabled = branchoffice?.tables_enabled === 1;
        const hasTableModule = Array.isArray(user?.modules) && checkUserModules('table_module', user.modules) !== -1;

        return hasTablesEnabled && hasTableModule ? '/reservation' : posPath;
    } catch (err) {
        return posPath;
    }
}
